import { render } from "./BlockedIcon.vue?vue&type=template&id=abd059ca"
const script = {}
script.render = render

export default script